// Components & Data Imports
import Header from '../layout/Header'
import AboutUs from '../layout/AboutUs'
import Event from '../layout/Event'
import Footer from '../layout/Footer'

const MainPage = () => {
  return (
    <>
      <Header />
      <AboutUs />
      <Event />
      <Footer />
    </>
  )
}

export default MainPage
